import { render } from "./MyFeedback.vue?vue&type=template&id=dffaf822&scoped=true"
import script from "./MyFeedback.vue?vue&type=script&lang=js"
export * from "./MyFeedback.vue?vue&type=script&lang=js"

import "./MyFeedback.vue?vue&type=style&index=0&id=dffaf822&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dffaf822"]])

export default __exports__